import React, {useEffect, useState} from 'react';

import {
    Button, Col, Container, Input, Row, Select, Tooltip
} from "design-react-kit";
import {properties} from "../../../config/properties";
import {useNavigate} from "react-router-dom";
import CustomTooltip from "../../utils/customToolTip";

const styles = {
    formContainer: {
        padding: '2rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        border: '1px solid #ddd'
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',
        paddingBottom: '0.5rem'
    },
};

const RicercaSpecimen = () => {

    const [camere, setCamere] = useState([]);
    const [cciaa, setCciaa] = useState('*');
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [resetCount, setResetCount] = useState(0);

    // Stato per sapere su quale campo mostrare il tooltip
    const [tooltipField, setTooltipField] = useState(null);
    const [tooltipMessage, setTooltipMessage] = useState('');


    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            const data = await getCciaaList();
            setCamere(data);
        }
        fetchData();
    }, []);

    const handleConferma = () => {
        const datiRicerca = {
            offset : 0,
            limit : 10,
            dati : {
                nome,
                cognome,
                cciaa
            }
        };

        navigate('/private/elencoSpecimenRicercati', { state: { ricerca: datiRicerca } });
    };



    return (
        <Container className="bg-white py-5 py-lg-6">
            <h2 className={"mb-5"}>Cerca Persona</h2>
            <div className="bg-white py-5 py-lg-6">

                <Row >

                    <Col md={5}>
                        <div className="guidance-box lead">
                            <p>
                                È possibile cercare persone registrate nella piattaforma all’interno di tutte le Camere
                                di Commercio aderenti al servizio Specimen.
                            </p>

                        </div>
                    </Col>

                    <Col md={7} lg={6}>
                        <div style={styles.formContainer}>
                            <h3 style={styles.formTitle}>
                                Filtri di ricerca
                            </h3>

                            <Row className="mb-5">
                                <Col>
                                    <Select
                                        key={resetCount}
                                        id="cciaa"
                                        label="CCIAA"
                                        value={cciaa}
                                        onChange={(e) => setCciaa(e)}
                                    >
                                        <option value="*">Qualsiasi</option>
                                        {camere.map((item, index) => (
                                            <option key={index} value={item.nomeProvincia}>
                                                {item.nomeProvincia}
                                            </option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>

                            <Row>
                                <Input
                                    id="nome"
                                    label="Inserisci Nome"
                                    type="text"
                                    wrapperClassName="col"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}

                                />
                            </Row>

                            <Row>
                                <Input
                                    id="cognome"
                                    label="Inserisci Cognome"
                                    type="text"
                                    wrapperClassName="col"
                                    value={cognome}
                                    onChange={(e) => setCognome(e.target.value)}
                                />
                            </Row>

                            <Row className="d-flex justify-content-end">
                                <Col sm="auto">
                                    <Button
                                        className={"btn btn-outline-warning"}
                                        outline
                                        onClick={() => {
                                            setNome('');
                                            setCognome('');
                                            setCciaa('*');
                                            setResetCount(prev => prev + 1);
                                            setTooltipField(null);
                                        }}
                                    >
                                        Cancella
                                    </Button>
                                </Col>
                                <Col sm="auto">
                                    <Button
                                        className={"btn btn-outline-primary"}
                                        type="submit"
                                        onClick={handleConferma}
                                    >
                                        Conferma
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>

            <CustomTooltip
                targetId={tooltipField}
                message={tooltipMessage}
                isOpen={tooltipField !== null}
                toggle={() => setTooltipField(null)}
            />

        </Container>
    );
};

export default RicercaSpecimen;

async function getCciaaList() {
    try {
        const res = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/list/cciaa");
        if (!res.ok) throw new Error("Errore HTTP");
        const json = await res.json();
        return json;
    } catch (e) {
        console.error("Errore nel caricamento delle CCIAA:", e);
        return [];
    }
}
